import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { NotificationInline } from '../../../../Notification'
import { Widget } from '../../../../Widget'
import { RentalPortalListingProfilePhotoEditorModal } from '../../RentalPortalListingProfilePhotoEditorModal'
import { QA_NAME_LISTING_PROFILE_WIDGET_PUBLISHING } from '../RentalPortalListingProfile.constants'

import { ListingProfileWidgetPublishingCollapseButton } from './ListingProfileWidgetPublishingCollapseButton'
import { ListingProfileWidgetPublishingReadiness } from './ListingProfileWidgetPublishingReadiness'
import { ListingProfileWidgetPublishingSkeleton } from './ListingProfileWidgetPublishingSkeleton'
import { ListingProfileWidgetPublishingSummary } from './ListingProfileWidgetPublishingSummary'
import { QA_NAME_LISTING_PROFILE_SCHEDULE_REFUSAL } from './RentalPortalListingProfileWidgetPublishing.constants'
import { useListingProfileWidgetPublishing } from './RentalPortalListingProfileWidgetPublishing.hooks'

import * as styles from './RentalPortalListingProfileWidgetPublishing.module.css'

function RentalPortalListingProfileWidgetPublishing() {
  const { t } = useTranslation()

  const {
    doneCount,
    handleClickManagePublishing,
    handleToggleReadiness,
    isComplete,
    isExpanded,
    isManageDisabled,
    isPhotoEditorOpen,
    isSkeleton,
    listingStatus,
    manageTooltipKey,
    photoEditorProps,
    readinessFixHandlers,
    readinessRows,
    scheduleRefusalText,
    total,
  } = useListingProfileWidgetPublishing()

  return (
    <>
      <Widget
        isExpanded
        contentContainerProps={{
          Skeleton: ListingProfileWidgetPublishingSkeleton,
          className: styles.content,
        }}
        headerProps={{
          contentProps: {
            actionsProps: {
              EditButton: null,
              ExpandButton: ListingProfileWidgetPublishingCollapseButton,
              expandButtonProps: {
                isDisabled: !isComplete,
                isExpanded,
                tooltipKey:
                  'RentalPortal.ListingProfileReadinessCollapseBlockedTooltipKey',
                onToggle: handleToggleReadiness,
              },
            },
          },
        }}
        isSkeleton={isSkeleton}
        qaName={QA_NAME_LISTING_PROFILE_WIDGET_PUBLISHING}
        title={t('RentalPortal.ListingProfilePublishingWidgetTitleKey')}
        onToggleExpanded={handleToggleReadiness}
      >
        {scheduleRefusalText ? (
          <NotificationInline
            qaName={QA_NAME_LISTING_PROFILE_SCHEDULE_REFUSAL}
            text={scheduleRefusalText}
            type={NOTIFICATION_TYPE.warning}
          />
        ) : null}
        {isExpanded ? (
          <ListingProfileWidgetPublishingReadiness
            doneCount={doneCount}
            fixHandlers={readinessFixHandlers}
            isManageDisabled={isManageDisabled}
            listingStatus={listingStatus}
            manageTooltipKey={manageTooltipKey}
            rows={readinessRows}
            total={total}
            onClickManage={handleClickManagePublishing}
          />
        ) : (
          <ListingProfileWidgetPublishingSummary
            doneCount={doneCount}
            isManageDisabled={isManageDisabled}
            listingStatus={listingStatus}
            manageTooltipKey={manageTooltipKey}
            total={total}
            onClickManage={handleClickManagePublishing}
          />
        )}
      </Widget>
      {isPhotoEditorOpen ? (
        <RentalPortalListingProfilePhotoEditorModal {...photoEditorProps} />
      ) : null}
    </>
  )
}

export default RentalPortalListingProfileWidgetPublishing
